export const omitProps = (toDelete, props) => {
  let clone = { ...props };
  toDelete.forEach((e) => props[e] && delete clone[e]);

  return clone;
};
